import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'getValidationIcon',
    standalone: true,
})
export class GetValidationIconPipe implements PipeTransform {
  transform(
    fontAwesomeIconClass: string,
    ...[qnAnswered, qnValid, qnDisabled]: boolean[]
  ): { tooltip: string; faIconClass: string } {
    let tooltip = '';
    let faIconClass = '';

    if (qnDisabled) {
      tooltip = 'Disabled/Non-editable Response';
      faIconClass = 'cursor-pointer fa fa-ban text-disabled';
    } else {
      if (qnAnswered === true) {
        if (qnValid === true) {
          tooltip = 'Valid Response';
          faIconClass = 'cursor-pointer fa fa-check-circle text-success';
        } else if (qnValid === false) {
          tooltip = 'Invalid Response';
          faIconClass = 'cursor-pointer fa fa-warning text-danger';
        }
      } else {
        tooltip = 'Mandatory question not answered';
        faIconClass = 'cursor-pointer fa fa-exclamation-circle text-warning';
      }
    }

    return { tooltip, faIconClass };
  }
}
